<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { AppInput } from '@shared/ui/inputs'
import { AppMultiSelectSearchable } from '@shared/ui/selects'
import { NativeSelect } from '@shared/ui/fields'

import { useFiltersCustomers } from '../../model/list/filters-customers.hook'

defineOptions({
  name: 'FiltersCustomers',
})

const {
  refSearch,
  refDateRange,
  refStages,
  statusValue,
  statusOptions,
  stageOptions,
  setStatus,
  isLoading,
  submitSearch,
  clearFilters,
} = useFiltersCustomers()
</script>

<template>
  <FiltersBar
    class="filters-customers"
    :loading="isLoading"
    @click:submit="submitSearch"
    @click:clear="clearFilters"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        class="filters-customers__search"
        label="Search"
        placeholder="Search"
        :disabled="isLoading"
      />

      <FilterDateRange
        v-model="refDateRange"
        class="filters-customers__date"
        label="Date"
        placeholder="Search"
        :disabled="isLoading"
      />

      <AppMultiSelectSearchable
        v-model="refStages"
        class="filters-customers__stage"
        :options="stageOptions"
        label="Stage"
        placeholder="All"
        clearable
        :disabled="isLoading"
      />

      <NativeSelect
        class="filters-customers__status"
        name="select_customer_status"
        label="Status"
        :options="statusOptions"
        :value="statusValue"
        :disabled="isLoading"
        @change="setStatus"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersCustomers.scss" />
